import React from 'react';
export const FORM_CLAIM = ({ isCrossModel }) => {
  const span = 24;
  return [
    {
      name: 'claimCode',
      label: 'QRCode การแจ้งเคลมจากลูกค้า',
      type: 'INPUT_QR_TWO',
      span,
    },
    {
      name: 'productName',
      label: 'ชื่อสินค้า',
      type: 'INPUT_AREA',
      disabled: true,
      style: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        minHeight: '32px',
        height: 'auto',
        width: '100%',
        resize: 'none',
      },
      autoSize: { minRows: 1, maxRows: 3 },
      span,
    },
    {
      name: 'mobileBrandName',
      label: 'แบรนด์',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'mobileModelName',
      label: 'รุ่น',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'breakdownName',
      label: 'อาการเสีย',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'bookingDate',
      label: 'วันที่จอง',
      type: 'INPUT',
      disabled: true,
      span,
    },
    
    {
      name: 'storeName',
      label: 'สาขาส่งสินค้าเคลม',
      type: 'INPUT',
      disabled: true,
      span,
    },
   
    {
      name: 'isCrossModel',
      label: 'ประเภทการเคลม',
      type: 'RADIO',
      properties: {
        options: [
          {
            label: 'ตรงรุ่น',
            value: 'false',
          },
          {
            label: 'เคลมข้ามรุ่น',
            value: 'true',
          },
        ],
      },
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'showInfo',
      label: (
        <span style={{ color: 'red' }}>หมายเหตุ : หากเป็นการเคลมข้ามรุ่น กรุณาระบุรหัสสินค้า</span>
      ),
      type: 'TEXT',
      span,
    },
    ...(isCrossModel === 'true')
      ? [
          {
            name: 'itemCode',
            label: 'รหัสสินค้า',
            type: 'INPUT_QR_CODE',
            span,
            rules: {
              required: true,
            },
          },
        ]
      : [],
    {
      name: 'warrantyNumberCode',
      label: 'รหัสรับประกัน หรือ QRCode สินค้า',
      type: 'INPUT_QR_TWO',
      disabled: false,
      span,
    },
  ];
};
